/* assets/cart-pack-strict.js
   Non-destructive overlay: fixes pack discount per-product & by quantity.
   Remove this file to revert instantly to the previous behavior.
*/
(function () {
  // If you want a kill-switch:
  if (window.CELIATI_PACK_STRICT === false) return;

  function fmtMAD(n) {
    try { return new Intl.NumberFormat('fr-MA',{style:'currency',currency:'MAD'}).format(n); }
    catch (_) { return 'MAD ' + (Math.round(n*100)/100).toFixed(2); }
  }
  function rateForQty(q) { return q >= 3 ? 0.10 : (q === 2 ? 0.05 : 0); }

  function readLines() {
    return Array.from(document.querySelectorAll('[data-cart-line]')).map(function (el) {
      return {
        el,
        product_id: Number(el.getAttribute('data-product-id')),
        eligible: String(el.getAttribute('data-eligible')) === 'true',
        qty: Number(el.getAttribute('data-qty') || '1'),
        unit: Number(el.getAttribute('data-unit-price') || '0') // ORIGINAL unit price
      };
    });
  }

  function groupEligible(lines) {
    var g = {};
    lines.forEach(function (l) {
      if (!l.eligible) return;
      if (!g[l.product_id]) g[l.product_id] = { qty: 0, lines: [] };
      g[l.product_id].qty += l.qty;
      g[l.product_id].lines.push(l);
    });
    return g;
  }

  function recalc() {
    var lines = readLines();
    var groups = groupEligible(lines);

    // Build per-product rate map (key: product_id)
    var rates = {};
    Object.keys(groups).forEach(function (pid) {
      rates[pid] = rateForQty(groups[pid].qty);
    });

    // Repaint UI based on original prices and our per-product rates
    var subtotal = 0, discount = 0;

    lines.forEach(function (l) {
      var r = l.eligible ? (rates[l.product_id] || 0) : 0;
      var lineBase = l.unit * l.qty;
      var lineDisc = lineBase * r;
      var unitDisplay = r > 0 ? l.unit * (1 - r) : l.unit;

      var u = l.el.querySelector('[data-unit-price-text]');
      if (u) u.textContent = fmtMAD(unitDisplay);

      var lp = l.el.querySelector('[data-line-price-text]');
      if (lp) lp.textContent = fmtMAD(lineBase - lineDisc);

      subtotal += lineBase;
      discount += lineDisc;
    });

    var subEl = document.querySelector('[data-cart-subtotal]');
    if (subEl) subEl.textContent = fmtMAD(subtotal);

    var row = document.querySelector('[data-pack-discount-row]');
    var discEl = document.querySelector('[data-pack-discount]');
    if (row && discEl) {
      if (discount > 0.009) { row.style.display = ''; discEl.textContent = fmtMAD(discount); }
      else { row.style.display = 'none'; discEl.textContent = fmtMAD(0); }
    }

    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = fmtMAD(subtotal - discount);
  }

  // Initial pass
  recalc();

  // Re-run after theme changes
  document.addEventListener('change', function (e) {
    if (e.target && /updates\[\]/.test(e.target.name || '')) setTimeout(recalc, 120);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-remove]') || e.target.name === 'remove') setTimeout(recalc, 200);
  });
  // Observe DOM re-renders (Dawn AJAX)
  new MutationObserver(function(){ setTimeout(recalc, 20); })
    .observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
})();